import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxIconModule } from '../icon/icon.module';
import { PhxButtonComponent } from './phx-button.component';

@NgModule({
  declarations: [
    PhxButtonComponent,
  ],
  imports: [
    CommonModule,
    PhxIconModule
],
  exports: [
    PhxButtonComponent,
  ]
})
export class PhxButtonModule { }
